import { c as _c } from "react/compiler-runtime";
import { grey, HEX_ALPHA, Tooltip } from "@flat-ui";
import { alpha, Box } from "@mui-wrapper";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * Displays an item of the view mode selector
 */
export function ViewModeSelectorItem(t0) {
  const $ = _c(21);
  const {
    isActive,
    component,
    tooltipTitle,
    onClick
  } = t0;
  const Icon = component;
  const t1 = isActive ? "background.paper" : undefined;
  let t2;
  if ($[0] !== isActive) {
    t2 = isActive ? `0px 1px 2px ${alpha(grey[0], HEX_ALPHA.alpha14)}` : undefined;
    $[0] = isActive;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isActive ? "default" : "pointer";
  let t4;
  if ($[2] !== t3) {
    t4 = {
      cursor: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isActive ? "primary.main" : PALETTE_VARS.text.primary;
  let t6;
  if ($[4] !== t5) {
    t6 = getSvgColoredIconCss(t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4 || $[9] !== t6) {
    t7 = {
      backgroundColor: t1,
      borderRadius: "4px",
      width: "42px",
      height: "30px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: t2,
      "&:hover": t4,
      ...t6
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = isActive ? undefined : onClick;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      width: "18px",
      height: "18px",
      "& [class*='map-large-1']": {
        display: "none"
      }
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== Icon) {
    t10 = <Icon sx={t9} />;
    $[12] = Icon;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t7 || $[16] !== t8) {
    t11 = <Box component="div" sx={t7} onClick={t8}>{t10}</Box>;
    $[14] = t10;
    $[15] = t7;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== tooltipTitle) {
    t12 = <Tooltip component="div" title={tooltipTitle}>{t11}</Tooltip>;
    $[18] = t11;
    $[19] = tooltipTitle;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}